module.exports = __webpack_public_path__ + "img/電気回路_3_10.463713d7.png";